import { render, staticRenderFns } from "./PropertyValue.vue?vue&type=template&id=536712d6&scoped=true"
import script from "./PropertyValue.vue?vue&type=script&lang=js"
export * from "./PropertyValue.vue?vue&type=script&lang=js"
import style0 from "./PropertyValue.vue?vue&type=style&index=0&id=536712d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536712d6",
  null
  
)

export default component.exports